import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

interface SocialImportStatus {
  id: string
  status: 'pending' | 'running' | 'succeeded' | 'failed' | 'timed_out'
  network: string
  username: string
  totalResults: number | null
  errorMessage: string | null
}

const fetchSocialImportStatus = async (importId: string): Promise<SocialImportStatus> => {
  const { data } = await api.get<SocialImportStatus>(`/ft_import-contacts/${importId}/status`)
  return data
}

export const useFtGetSocialImportStatus = (importId: string | null, enabled: boolean = true) => {
  return useQuery<SocialImportStatus>({
    queryKey: ['ft_social_import_status', importId],
    queryFn: () => fetchSocialImportStatus(importId!),
    enabled: !!importId && enabled,
    refetchInterval: (query) => {
      const status = query.state.data?.status
      if (status === 'running' || status === 'pending') {
        return 3000
      }
      return false
    },
  })
}
